import api from './api';

export const transitionRuleService = {
  getAll: async (projectId) => {
    const response = await api.get('/transition-rules', { params: { projectId } });
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/transition-rules', data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/transition-rules/${id}`);
    return response.data;
  },

  bulkUpdate: async (projectId, rules) => {
    const response = await api.post('/transition-rules/bulk', { projectId, rules });
    return response.data;
  },

  checkTransition: async (projectId, fromStatus, toStatus) => {
    const response = await api.get('/transition-rules/check', {
      params: { projectId, fromStatus, toStatus },
    });
    return response.data;
  },
};

export default transitionRuleService;
